// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --footer-background-colour: #333333;
  --footer-link-colour: #fff;
  --nav-bar-background-colour: #fff;
  --product-content-padding: 0 10px;
}

.terms-and-conditions {
  padding: 0 10%;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
}

.terms-and-conditions-header {
  margin-bottom: 10px;
  font-size: 30px;
  color: #E3000E;
}

.terms-and-conditions-close-icon {
  position: absolute;
  top: 10px;
  right: calc(10% + 25px);
  font-size: 50px;
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.terms-and-conditions-content {
  margin-top: 40px;
}

@media screen and (max-width: 479px) {
  .terms-and-conditions-close-icon {
    right: 25px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
